import React from "react";
import { Link } from "react-router-dom";
import "./HomePage.css"; // Reuse your existing CSS for navbar/footer etc.

const LeagueSettings = () => {
  return (
    <div className="homepage-container">
      {/* Header with nav bar */}
      <header className="header">
        <nav className="nav-bar">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/managers" className="nav-link">Managers</Link>
          <Link to="/seasons" className="nav-link">Seasons</Link>
          <Link to="/league-settings" className="nav-link">League Settings</Link>
        </nav>
      </header>

      {/* Page Title */}
      <h1 className="footballin-title" style={{ marginTop: "1rem", textAlign: "center" }}>
        League Settings
      </h1>

      {/* Content - vertical stack, 80% width centered */}
      <main
        className="main-content"
        style={{
          width: "80vw",
          maxWidth: "900px",
          margin: "1.5rem auto",
          display: "block",
          boxSizing: "border-box",
        }}
      >
        {/* Basic Settings */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
          <h2 className="section-title">Basic Settings</h2>
          <p><strong>League Name:</strong> Footballin</p>
          <p><strong>Number of Teams:</strong> 10</p>
          <p><strong>Scoring Type:</strong> Head to Head Points, Point Per Reception</p>
          <p><strong>Format:</strong> League Manager</p>
          <p><strong>Make League Viewable to Public:</strong> No</p>
          <p><strong>Auto Reactivate:</strong> No</p>
        </section>

        {/* Draft Settings */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
          <h2 className="section-title">Draft Settings</h2>
          <p><strong>Draft Type:</strong> Snake</p>
          <p><strong>Draft Date:</strong> Aug 31, 2025 @ 9:00 PM EDT</p>
          <p><strong>Time Per Pick:</strong> 90 seconds</p>
          <p><strong>Draft Order:</strong> Randomized One Hour Prior to Draft Time</p>
        </section>

        {/* Rosters */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem", overflowX: "auto" }}>
          <h2 className="section-title">Roster</h2>
          <p><strong>Roster Size:</strong> 16</p>
          <p><strong>Total Starters:</strong> 10</p>
          <p><strong>Total on Bench:</strong> 6 (1 IR)</p>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "0.3rem" }}>Position</th>
                <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "0.3rem" }}>Starters</th>
                <th style={{ borderBottom: "1px solid #ccc", textAlign: "left", padding: "0.3rem" }}>Maximums</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Quarterback (QB)</td><td>1</td><td>4</td></tr>
              <tr><td>Team Quarterback (TQB)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Running Back (RB)</td><td>2</td><td>8</td></tr>
              <tr><td>Running Back/Wide Receiver (RB/WR)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Wide Receiver (WR)</td><td>2</td><td>8</td></tr>
              <tr><td>Wide Receiver/Tight End (WR/TE)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Tight End (TE)</td><td>1</td><td>4</td></tr>
              <tr><td>Flex (FLEX)</td><td>2</td><td>N/A</td></tr>
              <tr><td>Offensive Player Utility (OP)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Defensive Tackle (DT)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Defensive End (DE)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Linebacker (LB)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Defensive Line (DL)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Cornerback (CB)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Safety (S)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Defensive Back (DB)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Defensive Player Utility (DP)</td><td>0</td><td>N/A</td></tr>
              <tr><td>Team Defense/Special Teams (D/ST)</td><td>1</td><td>3</td></tr>
              <tr><td>Place Kicker (K)</td><td>1</td><td>3</td></tr>
              <tr><td>Punter (P)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Head Coach (HC)</td><td>0</td><td>No Limit</td></tr>
              <tr><td>Bench (BE)</td><td>6</td><td>N/A</td></tr>
              <tr><td>Injured Reserve (IR)</td><td>1</td><td>N/A</td></tr>
            </tbody>
          </table>
        </section>

        {/* Scoring */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
          <h2 className="section-title">Scoring</h2>
          <h3>Passing</h3>
          <ul>
            <li>Passing Yards (PY): 0.05</li>
            <li>TD Pass (PTD): 4</li>
            <li>Interceptions Thrown (INT): -2</li>
            <li>2pt Passing Conversion (2PC): 2</li>
            <li>Sacked (SK): 0.5</li>
          </ul>
          <h3>Rushing</h3>
          <ul>
            <li>Rushing Yards (RY): 0.1</li>
            <li>TD Rush (RTD): 6</li>
            <li>2pt Rushing Conversion (2PR): 2</li>
            <li>200+ yard rushing game (RY200): 1</li>
          </ul>
          <h3>Receiving</h3>
          <ul>
            <li>Receiving Yards (REY): 0.1</li>
            <li>Each reception (REC): 1</li>
            <li>TD Reception (RETD): 6</li>
            <li>2pt Receiving Conversion (2PRE): 2</li>
          </ul>
          <h3>Kicking</h3>
          <ul>
            <li>Each PAT Made (PAT): 1</li>
            <li>Each PAT Attempted (PATA): -1</li>
            <li>Total FG Missed (FGM): -1</li>
            <li>FG Made (0-39 yards) (FG0): 3</li>
            <li>FG Made (40-49 yards) (FG40): 4</li>
            <li>FG Made (50-59 yards) (FG50): 5</li>
            <li>FG Made (60+ yards) (FG60): 6</li>
          </ul>
          <h3>Team Defense / Special Teams</h3>
          <ul>
            <li>Kickoff Return TD (KRTD): 6</li>
            <li>Punt Return TD (PRTD): 6</li>
            <li>Interception Return TD (INTTD): 6</li>
            <li>Fumble Return TD (FRTD): 6</li>
            <li>Blocked Punt or FG return for TD (BLKKRTD): 6</li>
            <li>2pt Return (2PTRET): 2</li>
            <li>1pt Safety (1PSF): 1</li>
            <li>Each Sack (SK): 1</li>
            <li>Blocked Punt, PAT or FG (BLKK): 2</li>
            <li>Each Interception (INT): 2</li>
            <li>Each Fumble Recovered (FR): 2</li>
            <li>Each Fumble Forced (FF): 1</li>
            <li>Each Safety (SF): 2</li>
            <li>0 points allowed (PA0): 5</li>
            <li>1-6 points allowed (PA1): 4</li>
            <li>7-13 points allowed (PA7): 3</li>
            <li>14-17 points allowed (PA14): 1</li>
            <li>28-34 points allowed (PA28): -1</li>
            <li>35-45 points allowed (PA35): -3</li>
            <li>46+ points allowed (PA46): -5</li>
            <li>Less than 100 total yards allowed (YA100): 5</li>
            <li>100-199 total yards allowed (YA199): 3</li>
            <li>200-299 total yards allowed (YA299): 2</li>
            <li>350-399 total yards allowed (YA399): -1</li>
            <li>400-449 total yards allowed (YA449): -3</li>
            <li>450-499 total yards allowed (YA499): -5</li>
            <li>500-549 total yards allowed (YA549): -6</li>
            <li>550+ total yards allowed (YA550): -7</li>
          </ul>
          <h3>Miscellaneous</h3>
          <ul>
            <li>Kickoff Return TD (KRTD): 6</li>
            <li>Punt Return TD (PRTD): 6</li>
            <li>Fumble Recovered for TD (FTD): 6</li>
            <li>Total Fumbles Lost (FUML): -2</li>
            <li>Interception Return TD (INTTD): 6</li>
            <li>Fumble Return TD (FRTD): 6</li>
            <li>Blocked Punt or FG return for TD (BLKKRTD): 6</li>
            <li>2pt Return (2PTRET): 2</li>
            <li>1pt Safety (1PSF): 1</li>
          </ul>
        </section>

        {/* Teams and Divisions Settings */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
          <h2 className="section-title">Teams and Divisions Settings</h2>
          <p><strong>League Standings:</strong></p>
          <ul>
            <li>Four Loko Army</li>
            <li>Maverick</li>
            <li>FAFO</li>
            <li>Beats by Ray</li>
            <li>The Decision Makers</li>
            <li>RIP rashee 🙏</li>
            <li>Run it Back</li>
            <li>Ariza's Army</li>
            <li>Dave's Duds</li>
            <li>Rashad’s Fentmaxxers</li>
          </ul>
          <p><strong>Player Rules</strong></p>
          <p>Observe ESPN's Undroppable Players List: Yes</p>
          <p>Player Universe: NFL</p>
          <p><strong>Acquisition and Waiver Rules</strong></p>
          <p>Lineup Changes: Lock individually at Scheduled Gametime</p>
          <p>Player Acquisition System: Waivers</p>
          <p>Season Acquisition Limit: No Limit</p>
          <p>Waiver Period: 1 Day</p>
          <p>Waiver Order: Reset Each Week to Inverse Order of Standings</p>
          <p>Lock Transactions for Eliminated Teams During Playoffs: No</p>
          <p><strong>Trade Rules</strong></p>
          <p>Trade Limit: No Limit</p>
          <p>Trade Deadline: Nov 26, 2025 @ 12:00 PM EST</p>
          <p>Trade Review Period: 1 Day</p>
          <p>Votes Required to Veto Trade: LM Only Vetoes</p>
          <p><strong>Keepers Rules</strong></p>
          <p>Use Keepers for 2025 Season: No</p>
          <p>Use Keepers for 2026 Season: No</p>
        </section>

        {/* Regular Season Setup */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "1.5rem" }}>
          <h2 className="section-title">Regular Season Setup</h2>
          <p><strong>Start of Regular Season:</strong> NFL Week 1 (Start of Season)</p>
          <p><strong>Weeks Per Matchup:</strong> 1</p>
          <p><strong>Regular Season Matchups:</strong> 14</p>
          <p><strong>Matchup Tie Breaker:</strong> No tie breakers</p>
          <p><strong>Home Field Advantage:</strong> None</p>
          <p><strong>Bonus Wins and Losses:</strong> No</p>
        </section>

        {/* Playoff Bracket Setup */}
        <section className="card" style={{ padding: "1.5rem", marginBottom: "4rem" }}>
          <h2 className="section-title">Playoff Bracket Setup</h2>
          <p><strong>Playoff Teams:</strong> 7</p>
          <p><strong>Weeks In Round 1 Playoff Matchup:</strong> 1</p>
          <p><strong>Weeks In Round 2 Playoff Matchup:</strong> 1</p>
          <p><strong>Weeks In Championship Round:</strong> 1</p>
          <p><strong>Playoff Seeding Tie Breaker:</strong> Total Points For</p>
          <p><strong>Playoff Home Field Advantage:</strong> None</p>
          <p><strong>Allow for Playoff Bracket Reseeding:</strong> Off</p>
          <p><strong>Lock Transactions for Eliminated Teams During Playoffs:</strong> No</p>
          <p>To edit, go to Settings &gt; Transactions and Keepers</p>
        </section>
      </main>

      {/* Footer */}
      <footer className="footer" style={{ textAlign: "center" }}>
        Created by Nick Criss ⚡️
      </footer>
    </div>
  );
};

export default LeagueSettings;
